import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../AuthContext";
import "./CustomerSchemes.css"; // Make sure to create and style this CSS file similarly to Products.css
import GiftModal from "./GiftModal"; // Import GiftModal component

const CustomerSchemes = () => {
  const [schemes, setSchemes] = useState([]);
  const { isLoggedIn, mobile } = useAuth();
  const [isGiftModalOpen, setIsGiftModalOpen] = useState(false);
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [allGifts, setAllGifts] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [newSchemes, setNewSchemes] = useState([]); // New state for New Items Schemes
  const [schemeType, setSchemeType] = useState("old"); // State for toggling between old and new schemes

  const filteredSchemes = (schemeType === "old" ? schemes : newSchemes).filter(
    (scheme) => {
      if (!scheme.productInfo) return false;
      const searchLower = searchText.toLowerCase();
      const brandMatch = scheme.productInfo.brand_name
        .toLowerCase()
        .includes(searchLower);
      const compositionMatch = scheme.productInfo.compostion
        .toLowerCase()
        .includes(searchLower);
      const segmentMatch = scheme.productInfo.category
        .toLowerCase()
        .includes(searchLower);
      return brandMatch || compositionMatch || segmentMatch;
    }
  );

  useEffect(() => {
    if (isLoggedIn && mobile) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/api/customer-schemes/${mobile}`)
        .then((response) => {
          const filteredOldSchemes = response.data.filter(
            (scheme) => scheme.productInfo
          );
          setSchemes(filteredOldSchemes);
        })
        .catch((error) => {
          console.error("Error fetching schemes:", error);
        });

      axios
        .get(
          `${process.env.REACT_APP_API_URL}/api/customer-new-schemes/${mobile}`
        )
        .then((response) => {
          const filteredNewSchemes = response.data.filter(
            (scheme) => scheme.productInfo
          );
          setNewSchemes(filteredNewSchemes);
        })
        .catch((error) => {
          console.error("Error fetching new schemes:", error);
        });

      axios
        .get(`${process.env.REACT_APP_API_URL}/api/gifts`)
        .then((response) => {
          setAllGifts(response.data);
        })
        .catch((error) => {
          console.error("Error fetching gifts:", error);
        });

      setSchemeType("old"); // Reset to old schemes when customer changes
    }
  }, [isLoggedIn, mobile]);

  const handleSchemeClick = (scheme) => {
    setSelectedScheme(scheme);
    setIsGiftModalOpen(true);
  };

  const getImagePath = (company, imageName) => {
    // Base URL for images in production - adjust the domain as necessary
    let basePath = "";

    // console.log(company);

    // Determine the base path based on the company
    switch (company) {
      case "Trumac":
        basePath = "/app_admin/assets/images/products";
        break;
      case "Camrut":
        basePath = "/camrut_app_admin/assets/images/products";
        break;
      case "Medisync":
        basePath = "/medisync_app_admin/assets/images/products";
        break;
      case "Cialto Drugs":
        basePath = "/cialto_app_admin/assets/images/products";
        break;
      case "Pythus Pharma":
        basePath = "/pythus_app_admin/assets/images/products";
        break;
      default:
        basePath = "/images"; // Default path for development or fallback
    }

    // console.log(basePath);

    // Check if the environment is development or production
    // This is a basic check, you might need to adjust it based on your setup
    const isDevelopment =
      !process.env.NODE_ENV || process.env.NODE_ENV === "development";

    // console.log("mode : ", process.env.NODE_ENV);

    // Return the correct path
    return isDevelopment
      ? `https://trumachealthcare.net${basePath}/${imageName}`
      : `${basePath}/${imageName}`;
  };

  return (
    <div className="customer-schemes-container">
      <h1>Product Schemes</h1>
      <p>Click on the product to view schemes</p>
      <div className="scheme-toggle-buttons">
        <button
          onClick={() => setSchemeType("old")}
          className={schemeType === "old" ? "active" : ""}
        >
          Old / Regular Products Schemes
        </button>
        <button
          onClick={() => setSchemeType("new")}
          className={schemeType === "new" ? "active" : ""}
        >
          New Products Schemes
        </button>
      </div>

      <div className="sticky-search-bar">
        <input
          type="text"
          placeholder="Search brand name, composition, segment..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          className="search-input"
        />
      </div>
      <div className="schemes-grid">
        {filteredSchemes.map((scheme, index) => (
          <div
            key={index}
            className="scheme-card"
            onClick={() => handleSchemeClick(scheme)}
          >
            {scheme.productInfo ? (
              <>
                <img
                  src={getImagePath(
                    scheme.productInfo.company,
                    scheme.productInfo.product_image
                  )}
                  // src={scheme.productInfo.product_image} // Adjust as necessary for your image path
                  alt={scheme.productInfo.brand_name}
                  className="scheme-image"
                />
                <div className="scheme-info">
                  <h3>{scheme.productInfo.brand_name}</h3>
                  <p>
                    <strong>Composition:</strong>{" "}
                    {scheme.productInfo.compostion}
                  </p>
                  <p>
                    <strong>Packing:</strong> {scheme.productInfo.packing}
                  </p>
                  <p>
                    <strong>MRP:</strong> ₹{scheme.productInfo.mrp}
                  </p>
                  <p>
                    <strong>Rate:</strong> ₹{scheme[3]}/-
                  </p>
                  <p>
                    <strong>Company:</strong> {scheme.productInfo.company}
                  </p>
                  <span className="view-schemes-link">
                    Click to View Schemes
                  </span>{" "}
                  {/* Link to view schemes */}
                </div>
              </>
            ) : (
              <p>Product details not available.</p>
            )}
          </div>
        ))}
      </div>
      <GiftModal
        isOpen={isGiftModalOpen}
        onClose={() => setIsGiftModalOpen(false)}
        scheme={selectedScheme}
        gifts={allGifts}
      />
    </div>
  );
};

export default CustomerSchemes;
